import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import Seo from "../components/Seo";

export default function ShopClosed() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center">
      <Seo
        title="Shop momentaneamente sospeso"
        description="Gli acquisti online e il catalogo pneumatici sono momentaneamente sospesi. Contatta un punto vendita Puntogomme Lazio."
        canonical="/"
        noindex
      />
      <p className="text-xs font-bold text-pg-red uppercase tracking-widest mb-3">Shop online</p>
      <h1 className="text-3xl md:text-4xl font-black text-gray-900 tracking-tight mb-4">
        Acquisti momentaneamente sospesi
      </h1>
      <p className="text-pg-gray leading-relaxed mb-8">
        Il catalogo non è al momento visibile e non è possibile completare ordini dal sito.
        Per pneumatici e servizi puoi chiamarci o passare in uno dei punti vendita.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
        <a href="tel:+39069004128" className="btn-primary">
          <Phone size={16} /> 06 900 41 28
        </a>
        <a href="mailto:info@puntogommelazio.it" className="btn-secondary">
          <Mail size={16} /> info@puntogommelazio.it
        </a>
      </div>
      <Link to="/#punti-vendita" className="text-sm font-semibold text-pg-red hover:underline">
        Vedi i punti vendita
      </Link>
    </div>
  );
}
